export const GET_ALL_API_KEY = 'api_key/all'
export const CREATE_API_KEY = 'api_key/create'
export const DELETE_API_KEY = 'api_key/delete'
